﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { DialogService } from "@app/services/dialog.service";
import { StorageService } from "@app/services/storage.service";
import { UploadService } from "@app/services/upload.service";
import { DialogButton, eFileSource, eFileStatus, eInputDialogType, IKbFile, IQuoteFile, IRootScope, MediaDialogButton } from "@models";
import { icons } from "@tools";

@NgComponent({
    token: Token.KbAttachments,
    dependencies: [
        Token.$RootScope,
        Token.DialogService,
        Token.$Http,
        Token.$Q,
        Token.UploadService,
        Token.StorageService
    ]
})
export class KbAttachments extends Directive {

    constructor(
        private $rootScope: IRootScope,
        private dialogService: DialogService,
        private $http: ng.IHttpService,
        private $q: ng.IQService,
        private uploadService: UploadService,
        private storageService: StorageService
    ) {
        super();

        this.replace = false;
        this.template = Dirs.component("kb-attachments");
        this.restrict = "E";
        this.scope = {
            objectId: "=",
            tableName: "@",
            relationshipProperty: "@",
            files: "=",
            fileEntityPath: "@",
            canChange: "=",
            canAdd: "=",
            downloadFile: "="
        };

        this.link = (scope: any, element, atts: any) => {
            if (typeof scope.canChange == "undefined") {
                scope.canChange = $rootScope.user.canModifyAllAttachments || $rootScope.user.canAddAttachments;
            }
            if (typeof scope.secureFileDownloadUrl == "undefined") scope.secureFileDownloadUrl = "file/download";

            let displayDialog = (callback, file?, name: string = "", description: string = "", source?) => {
                let fileInfo = scope.$new(true);
                if (!file) file = { name: "" };
                let mediaButton = "";

                fileInfo.model = {
                    fileName: file.name,
                    name,
                    description,
                    source
                };

                fileInfo.canViewMedia = this.$rootScope.context.user.canModifyMedia;

                dialogService.dialog({
                    type: eInputDialogType.html,
                    template: Dirs.view("dialog-edit-attachment"),
                    scope: fileInfo,
                    buttons: [
                        new DialogButton(loc.ok, icons.submit, () => {
                            callback(fileInfo.model.name, fileInfo.model.description, file, fileInfo.model.source);
                        }),
                        new DialogButton(loc.cancel, icons.cancel)]
                });

                fileInfo.uploadNewAttachment = () => {
                    this.uploadService.promptUserToChooseFile(atts.accept).then(selectedFile => {
                        if (file.name == fileInfo.model.name || !fileInfo.model.name) {
                            fileInfo.model.name = selectedFile.name;
                        }
                        fileInfo.model.fileName = selectedFile.name;
                        fileInfo.model.source = eFileSource.uploaded;
                        file = selectedFile;
                    });
                };

                fileInfo.selectMediaFile = () => {
                    let name = fileInfo.model.name;
                    let description = fileInfo.model.description;
                    dialogService.mediaSelect({
                        buttons: [
                            new MediaDialogButton(loc.ok, icons.success, args => {
                                if (!name || name == file.name) {
                                    fileInfo.model.name = args.selectedItem.name;
                                }
                                fileInfo.model.fileName = args.selectedItem.name;
                                fileInfo.model.source = eFileSource.media;
                                file = args.selectedItem;
                            }),
                            new MediaDialogButton(loc.cancel, icons.cancel, args => {

                            })
                        ]
                    });
                };
            };

            if (!scope.downloadFile) {
                scope.downloadFile = item => {
                    if (typeof window != "undefined") {
                        window.open(storageService.getMediaUrl(item.filePath));
                    }
                };
            }

            scope._uploadFile = (item?: IQuoteFile) => {
                if (!item) { item = {
                    filePath: "",
                    name: "",
                    description: "",
                    source: null
                };
                }
                displayDialog((name, description, file, source) => {
                    let promise;
                    let newFileEntity: IKbFile = {
                        name,
                        description,
                        id: item.id,
                        filePath: file.name,
                        // idCompany: $rootScope.company.id,
                        // idUser: $rootScope.user.id,
                        createdBy: $rootScope.user.id,
                        // tableName: scope.tableName,
                        createdByName: $rootScope.user.firstName + " " + $rootScope.user.lastName,
                        source: null,
                        status: eFileStatus.complete
                    };
                    if (source) newFileEntity.source = source;
                    if (newFileEntity.source == eFileSource.media) newFileEntity.filePath = file.name;
                    if (scope.objectId && scope.relationshipProperty) {
                        newFileEntity[scope.relationshipProperty] = scope.objectId;
                    }
                    if (file && source != eFileSource.media) {
                        let url = scope.postUrl;
                        let deferred = $q.defer();
                        dialogService.alert({
                            promise: deferred.promise,
                            successMsg: "Upload complete"
                        });

                        let uploadProgress = evt => {
                            if (evt.lengthComputable) {
                                deferred.notify(Math.round(evt.loaded * 100 / evt.total));
                            } else {
                                deferred.notify("Unknown File Size");
                            }
                        };

                        let uploadComplete = (result) => {
                            deferred.resolve();
                            if (item.id) {
                                $.extend(item, newFileEntity);
                            } else {
                                newFileEntity.id = result.id;
                                scope.files.push(newFileEntity);
                            }
                        };

                        let uploadFailed = () => {
                            deferred.reject("Upload failed");
                        };

                        let uploadCanceled = () => {
                            deferred.reject();
                        };

                        this.uploadService.uploadAttachment(file, newFileEntity, scope.fileEntityPath)
                            .then(uploadComplete, uploadFailed, uploadProgress);
                    } else {
                        if (item.id) {
                            $.extend(item, newFileEntity);
                            $http.put(scope.fileEntityPath, newFileEntity);
                        } else {
                            scope.files.push(newFileEntity);
                            $http.post(scope.fileEntityPath, newFileEntity);
                        }
                    }
                }, { name: item.filePath, isFromMedia: true }, item.name, item.description, item.source);
            };

            scope.delete = item => {
                this.dialogService.confirm(loc.msg_confirmdelete, () => {
                    scope.files.remove(item);
                    this.$http.delete(scope.fileEntityPath + "/" + item.id);
                });
            };
        };
    }

}
